export default {
    to: "/dashboard/board",
    order: 3,
    icon: "mdi-account-multiple",
    title: "Board Members",
    disabled: false,
    value: 0,
    sublinks: [],
}
